/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext, useEffect } from "react";
import { Typography, Table, DatePicker, Select, Space, Button } from "antd";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

const { Title } = Typography;
const { Option } = Select;

export default function Holidays() {
  const isMobile = window.innerWidth < 768;
  const { authData, backUrl } = useContext(AuthContext);
  const [holidayData, setHolidayData] = useState([]);
  const [holidayOptions, setHolidayOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedYear, setSelectedYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [holidayName, setHolidayName] = useState(null);

  const fetchHolidays = async ({
    yearOverride,
    monthOverride,
    fromOverride,
    toOverride,
    nameOverride,
  } = {}) => {
    setLoading(true);
    try {
      const y = yearOverride ?? selectedYear;
      const m = monthOverride ?? month;
      const f = fromOverride ?? fromDate;
      const t = toOverride ?? toDate;
      const n = nameOverride ?? holidayName;

      const params = {};
      if (y) params.from_year = y;
      if (m) params.month = m;
      if (f) params.from_date = f.format("YYYY-MM-DD");
      if (t) params.to_date = t.format("YYYY-MM-DD");
      if (n) params.holiday_name = n;

      const res = await axios.get(`${backUrl}/api/hr/holidays/`, {
        headers: { Authorization: `Bearer ${authData.access}` },
        params,
      });

      let list = res.data.results ? res.data.results : Array.isArray(res.data) ? res.data : [];
      list = list.map((item) => ({
        ...item,
        holiday_date: item.holiday_date ? dayjs(item.holiday_date).format("YYYY-MM-DD") : null,
      }));

      setHolidayData(list);

      // Populate holiday name dropdown dynamically
      const uniqueNames = [...new Set(list.map((h) => h.holiday_name).filter(Boolean))];
      setHolidayOptions(uniqueNames);
    } catch (error) {
      console.error("fetchHolidays error:", error);
      toast.error("Failed to fetch holidays!");
      setHolidayData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHolidays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Auto-fetch when filters change
  useEffect(() => {
    if ((fromDate && !toDate) || (!fromDate && toDate)) return;
    fetchHolidays();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedYear, month, fromDate, toDate, holidayName]);

  const clearFilters = () => {
    setSelectedYear(null);
    setMonth(null);
    setFromDate(null);
    setToDate(null);
    setHolidayName(null);
    fetchHolidays({ yearOverride: null, monthOverride: null, fromOverride: null, toOverride: null, nameOverride: null });
  };

  const onMonthChange = (date) => {
    if (!date) {
      setMonth(null);
      return;
    }
    setMonth(date.month() + 1);
    if (!selectedYear) setSelectedYear(String(date.year()));
  };

  const FilterHolidays = () => {
    const monthValue = month ? dayjs(`${selectedYear || dayjs().year()}-${String(month).padStart(2, "0")}`, "YYYY-MM") : null;

    return (
      <div className="d-flex justify-content-center align-items-center pt-2" style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: isMobile ? "center" : "space-between",
        alignItems: "center",
        gap: isMobile ? "10px" : "12px",
        paddingTop: "10px",
      }}>
        <DatePicker
          picker="year"
          placeholder="Select Year"
          value={selectedYear ? dayjs(selectedYear, "YYYY") : undefined}
          onChange={(date, dateString) => setSelectedYear(dateString || null)}
          style={{
            width: isMobile ? "100%" : 180,
          }}
          allowClear
        />
        <DatePicker
          picker="month"
          placeholder="Select Month"
          value={monthValue || undefined}
          onChange={onMonthChange}
          style={{
            width: isMobile ? "100%" : 180,
          }}
          allowClear
        />
        <DatePicker
          placeholder="From Date"
          format="DD/MM/YYYY"
          value={fromDate || undefined}
          onChange={(date) => setFromDate(date)}
          style={{
            width: isMobile ? "100%" : 180,
          }}
          allowClear
        />
        <DatePicker
          placeholder="To Date"
          format="DD/MM/YYYY"
          value={toDate || undefined}
          onChange={(date) => setToDate(date)}
          style={{
            width: isMobile ? "100%" : 180,
          }}
          allowClear
        />
        <Select
          showSearch
          allowClear
          placeholder="Select Holiday Name"
          value={holidayName || undefined}
          onChange={(value) => setHolidayName(value || null)}
          style={{
            width: isMobile ? "100%" : 220,
          }}
          filterOption={(input, option) => option?.children?.toLowerCase().includes(input.toLowerCase())}
        >
          {holidayOptions.map((name) => (
            <Option key={name} value={name}>
              {name}
            </Option>
          ))}
        </Select>
        {/* <Button danger onClick={clearFilters}>
          Clear Filters
        </Button> */}
      </div>
    );
  };

  const HolidayTable = () => {
    const columns = [
      { title: "Name", dataIndex: "holiday_name", key: "holiday_name" },
      { title: "Day", dataIndex: "holiday_day", key: "holiday_day" },
      { title: "Date", dataIndex: "holiday_date", key: "holiday_date" },
      { title: "Year", dataIndex: "year", key: "year" },
    ];

    return (
      <>
        <center>
          <FilterHolidays />
        </center>
        <br />
        <Table
          columns={columns}
          dataSource={holidayData}
          rowKey="id"
          loading={loading}
          bordered
          components={{
            header: {
              cell: (props) => <th {...props} style={{ backgroundColor: "#0e497b", color: "white" }}>{props.children}</th>,
            },
          }}
        />
      </>
    );
  };

  return (
    <div style={{ padding: 20 }}>
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <Title level={4} style={{ color: "#0e497b" }}>Holiday List</Title>
      </div>
      <HolidayTable />
    </div>
  );
}
